import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export const AutoActiveContext = createContext({
    currentScreenId: null,
});
export function AutoActiveProvider({ screenId, children }) {
    return (_jsx(AutoActiveContext.Provider, { value: { currentScreenId: screenId }, children: children }));
}
export function useAutoActive() {
    return useContext(AutoActiveContext);
}
/**
 * Hook to determine if an element should be auto-active.
 * Returns true if the element has a :to prop that matches the current screen.
 *
 * Auto-active does NOT apply to:
 * - Overlay references (starting with #)
 * - Action keywords (starting with :)
 */
export function useIsAutoActive(element) {
    const { currentScreenId } = useAutoActive();
    const toTarget = element.props.to;
    if (!toTarget)
        return false;
    if (!currentScreenId)
        return false;
    // Handle structured format from DSL type casting (e.g., { type: 'screen', id: 'contacts' })
    if (typeof toTarget === 'object' && toTarget !== null && 'type' in toTarget) {
        const ref = toTarget;
        if (ref.type === 'screen' && ref.id) {
            return ref.id === currentScreenId;
        }
        return false; // overlay or action refs don't auto-activate
    }
    // Handle legacy string format
    if (typeof toTarget !== 'string')
        return false;
    if (toTarget.startsWith('#'))
        return false; // overlay reference
    if (toTarget.startsWith(':'))
        return false; // action keyword
    return toTarget === currentScreenId;
}
//# sourceMappingURL=AutoActiveContext.js.map